<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates43">
<p class="centerImage"><img alt="images" id="plate43" src="images/plate43.jpg"/></p>
<p class="caption">Flying Officer Tony Hughes celebrating his encounter with the enemy on 20 June even though he had to make a forced landing.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates43.vue?15cc3c86